import { render, staticRenderFns } from "./Deliverables.vue?vue&type=template&id=53c54ca7&"
import script from "./Deliverables.vue?vue&type=script&lang=js&"
export * from "./Deliverables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c54ca7')) {
      api.createRecord('53c54ca7', component.options)
    } else {
      api.reload('53c54ca7', component.options)
    }
    module.hot.accept("./Deliverables.vue?vue&type=template&id=53c54ca7&", function () {
      api.rerender('53c54ca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/Deliverables.vue"
export default component.exports